module.exports = __webpack_public_path__ + "static/media/产品介绍.7e0a5c2.mp4";


//////////////////
// WEBPACK FOOTER
// ./public/video/产品介绍.mp4
// module id = ep35
// module chunks = 1